export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Cinematic%20warm%20gradient%20with%20soft%20bokeh%20lights%20in%20golden%20and%20amber%20tones%2C%20abstract%20movie%20theater%20ambiance%2C%20elegant%20dark%20background%20with%20light%20rays%2C%20luxurious%20and%20warm%20atmosphere%2C%20fine%20art%20style&width=1800&height=600&seq=cta-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/80"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4">开始你的追剧之旅</h2>
        <p className="text-white/70 text-sm md:text-base mb-8 max-w-lg mx-auto">
          聚合全网热播影视资源，高清在线观看，每日更新，完全免费。现在就加入嫩草视频，追剧不等待！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="/category/reboju"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            立即浏览影视库
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="/about"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white rounded-full text-sm font-medium backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </a>
        </div>
      </div>
    </section>
  );
}